// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--1waoc","icon":"dd31006766--icon--34jKX","message":"dd31006766--message--2ro90"};